import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ToastService } from '../../../services/toast.service';
import { environment } from '../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss',
    standalone: false,
  host: {
    class: 'row flex-grow-1'
  }
})
export class RegisterComponent {
	constructor(
		private route: ActivatedRoute,
		private router: Router,
        private authService: AuthService,
        private toastService: ToastService,
        private spinner: NgxSpinnerService
	) {}

    cardForm = new FormGroup({
        userName: new FormControl('', Validators.required),
        password: new FormControl('', Validators.required),
    });

    showSuccessToast() {
        this.toastService.show('Successfully registered!', { header: 'Registration Success', classname: 'bg-success text-light' });
    }
    showFailureToast() {
        this.toastService.show('Failed to register!', { header: 'Registration Failed', classname: 'bg-danger text-light' });
    }
    
    async submit() {
        this.spinner.show();

        const body = JSON.stringify({
            email: this.cardForm.value.userName,
            password: this.cardForm.value.password
        });

        await fetch(`${environment.authUrl}/auth/register`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body,
        }).then(data => {
            if (data.ok) {
                this.showSuccessToast();
                this.cardForm.reset();
            } else {
                this.showFailureToast();
                throw new Error('Network request failed ' + data.statusText);
            }
            return data.json();
        }).then(responseJson => {
            this.router.navigateByUrl('/login');
        }).catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        }).finally(() => {
            this.spinner.hide();
        });
    }
}
